<template>
  <div id="map-placeholder">
    <slot></slot>
    <div class="ui buttons">
      <!-- <toggle-layer-button-component
        id="observations"
        @toggleLayer="toggleLayer($event)"
      >Observation</toggle-layer-button-component>-->
      <!-- <toggle-layer-button-component id="datasets" @toggleLayer="toggleLayer($event)">Datasets</toggle-layer-button-component> -->
    </div>
    <div ref="mapContainer" class="map-container" @meta-obs-clicked="zoomInObs"></div>
    <div id="map" class="map"></div>
  </div>
</template>

<style>

#map {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
}

#map-placeholder {
  position: absolute;
  width: calc(70% - 40px);
  /*width: auto;*/
  height: 50%;
  right: 40px;
  top: 0;
  /*resize: horizontal;
  overflow: auto;*/
}

.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.ui.buttons {
  position: absolute;
  float: left;
  z-index: 999;
  margin-top: 20px;
  margin-left: 375px;
}
.ui.selectable.celled.table tbody {
  cursor:pointer;
}

/* Cluster Pie Chart CSS */

/*Marker clusters*/
.marker-cluster-pie g.arc{
  fill-opacity: 0.5;
}
.marker-cluster-pie-label {
  fill: white;
  font-size: 11px;
  /*font-weight: bolder;*/
  /*font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;*/
  font-family: Tahoma, Geneva, sans-serif;
}

/*marker categories*/
.category-CRYO{
  fill: rgb(113, 190, 211);
  stroke: #444444;
  stroke-width: 0.5;
}
.category-EDYT{
  fill: rgb(161, 54, 54);
  stroke: #444444;
  stroke-width: 0.5;
}
.category-LACS{
  fill: rgb(75, 121, 185);
  stroke: #444444;
  stroke-width: 0.5;
}
.category-ORCH{
  fill: rgb(87, 122, 58);
  stroke: #444444;
  stroke-width: 0.5;
}
.category-OURA{
  fill: rgb(110, 50, 138);
  stroke: #444444;
  stroke-width: 0.5;
}
.category-METF{
  fill: rgb(43, 26, 119);
  stroke: #444444;
  stroke-width: 0.5;
}

</style>

<script>

//import Map from 'ol/Map.js';
//import View from 'ol/View.js';
//import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
//import {Cluster, OSM, Vector as VectorSource} from 'ol/source.js';
//import {fromLonLat} from 'ol/proj.js';
//import GeoJSON from 'ol/format/GeoJSON.js';
//import Feature from 'ol/Feature.js';
//import {Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style.js';
//import Point from 'ol/geom/Point.js';
   
import { mapActions, mapGetters, getFilters } from "vuex";
import toggleLayerButtonComponent from "./toggle-layer-button-component.vue";

import * as d3 from "d3/dist/d3.js";

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw';
import 'leaflet-draw/dist/leaflet.draw.css';
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";

/*
import "leaflet/dist/leaflet.css";

//import 'leaflet/dist/leaflet.css' 
import 'leaflet/dist/leaflet' 
import 'leaflet-draw/dist/leaflet.draw' 
import 'leaflet-draw/dist/leaflet.draw.css'



import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
//import L from "leaflet";
import "leaflet.markercluster";

// Import images directly that got missed via the CSS imports above.
import 'leaflet/dist/images/marker-icon-2x.png';
import 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/images/marker-shadow.png';
*/




/**
 * Problem with Webpack + Leaflet: webpack move icon images and hash there name.
 * Then leaflet path detection is not able to find images anymore. Leaflet members don't seem
 * them want to fix the problem (closing all issues). More Info https://github.com/Leaflet/Leaflet/issues/4968
 * Workaround: delete default icon url and import new local path for each icon.
 */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});


/**
 * Add methods and attribute for Polyline to be included in marker cluster
 */
L.Polyline.addInitHook(function() {
  if (this._latlngs.length > 0) {
    this._latlng = this._bounds.getCenter();
  }
});
L.Polyline.include({
  getLatLng: function() {
    return this._latlng;
  },
  setLatLng: function() {} // Dummy method.
});





export default {
  name: "map-component",
  components: {
  },
  data() {
    return {
      map: null,
      drawnItems: null,
      markers: null,
      vectorSource: null,
      clusterSource: null,
      clusterLayer: null,
      tileLayer: null,
      layers: []
    };
  },
  computed: {
    ...mapGetters([
      "getMapItems",
      "getObservationsCount",
      "getObservationIdToZoomIn",
      "getDatasets",
      "getPopupTemplate",
      "getSettings",
      "getFilters"
    ])
  },
  watch: {
    //Each time the map items are updated the map is refreshed
    getMapItems() {
      this.refreshMapWithMarkers();
    }
  },
  methods: {

    //Vuex Store actions used by the component
    ...mapActions(["setObservationsDetailed", "loadPopupContent"]),

    initMap() {

      this.map = L.map(this.$refs["mapContainer"]).setView([47, 6], 6);

      this.drawnItems = L.featureGroup();
      this.map.addLayer(this.drawnItems);


this.map.addControl(new L.Control.Draw({
    edit: {
        featureGroup: this.drawnItems,
        edit: false
    },
    draw: {
        polygon: {
            allowIntersection: false,
            showArea: true
        },
          polyline: false,
          marker: false,
          circlemarker: false,
          circle: false

    }
}));

function itemDrawn(event) {

const layer = event.layer;
  this.drawnItems.clearLayers();
  this.getFilters.searchArea = "";
  this.drawnItems.addLayer(layer);
    var lng, lat, coords = [];
    var latlngs = layer.getLatLngs()[0];
    console.log(latlngs);
    for (var i = 0; i < latlngs.length; i++) {
      //console.loglatlngs[i]
      console.log(latlngs[i]);
	  	coords.push(latlngs[i].lng + " " + latlngs[i].lat);
	    if (i === 0) {
	     	lng = latlngs[i].lng;
	     	lat = latlngs[i].lat;
	    }
	  };
    this.getFilters.searchArea = "POLYGON((" + coords.join(",") + "," + lng + " " + lat + "))";

}

function itemDeleted() {
    this.getFilters.searchArea = "";
}


/*
     var drawControl = new L.Control.Draw({
         edit: {
             featureGroup: this.drawnItems
         }
     });
     this.map.addControl(drawControl);
*/
this.map.on(L.Draw.Event.CREATED, itemDrawn, this);

this.map.on(L.Draw.Event.DELETED, itemDeleted, this);



     /*

      this.map.addControl(new L.Control.Draw({
        edit: {
          featureGroup: this.drawnItems,
          poly: {
            allowIntersection: false
          }
        },
        draw: {
          polygon: {
            allowIntersection: false,
            showArea: true
          }
        }
      }));
*/


      /*

      this.map = L.map(this.$refs["mapContainer"]).setView([51.505, -0.09], 13);

      var marker = L.marker([51.5, -0.09]).addTo(this.map);

      var circle = L.circle([51.508, -0.11], {
        color: 'red',
        fillColor: '#f03',
        fillOpacity: 0.5,
        radius: 500
      }).addTo(this.map);

      var drawnItems = new L.FeatureGroup();
     this.map.addLayer(drawnItems);
     var drawControl = new L.Control.Draw({
         edit: {
             featureGroup: drawnItems
         }
     });
     this.map.addControl(drawControl);
*/

/*
      this.map = L.map(this.$refs["mapContainer"], {
        center: [47, 6],
        zoom: 6,
        maxZoom: 16,
        minZoom: 3,
        maxBounds: [
          //south west
          [85, Infinity],
          //north east
          [-85, -Infinity]
        ]
      });
      */

      this.tileLayer = L.tileLayer(
        "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}",
        {
          accessToken:
            "pk.eyJ1IjoiY2hhcmx5Y291IiwiYSI6ImNqY2x4dWdvZjBiMzMyeGxnNXQwOXNkY2QifQ.rM1M1C_dZ2XBKlbHK_8fpA",
          attribution:
            'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
          //id: "mapbox.satellite",
          id: "mapbox.streets",
          crs: L.CRS.EPSG4326
        }
      ).addTo(this.map);
      

      this.markers = {
        observations: L.markerClusterGroup(),
        datasets: L.markerClusterGroup()
      };


/*
      // FeatureGroup is to store editable layers
     var drawnItems = new L.FeatureGroup();
     this.map.addLayer(drawnItems);
     var drawControl = new L.Control.Draw({
         edit: {
             featureGroup: drawnItems
         }
     });
     this.map.addControl(drawControl);

      console.log("mapInitialised");
      */

/*
        this.vectorSource = new VectorSource({});
        //var vectorLayer = new VectorLayer({ source: this.vectorSource });

        this.clusterSource = new Cluster({
          distance: parseInt(50, 10),
          source: this.vectorSource,
          
          geometryFunction: function(feature) {
            var type = feature.getGeometry().getType();
            
            if (type == 'Point') {
              return feature;
            }
            
            //if (type == 'Polygon') {
            //  return feature.getGeometry().getInteriorPoint();
            //}

            //if (type == 'LineString') {
            //  return feature.getCentroid(true);
            //}

          }
          
        });

      var styleCache = {};
      this.clusterLayer = new VectorLayer({
        source: this.clusterSource,


        style: new ol.style.Style(
			    {	image: new ol.style.Chart(
				    {	type: "pie", 
					    radius: (sel?1.2:1)*radius, 
					    offsetY: $("#graph").val()=='pie' ? 0 : (sel?-1.2:-1)*feature.get("radius"),
					    data: feature.get("data") || [10,30,20], 
					    colors: /,/.test(c) ? c.split(",") : c,
					    rotateWithView: true,
					    animation: animation,
					    stroke: new ol.style.Stroke(
					    {	color: $("#color").val()!="neon" ? "#fff":"#000",
						    width: 2
					    }),
				    })
			    });

        
        style: function(feature) {
          var size = feature.get('features').length;
          var style = styleCache[size];
          if (!style) {
            style = new Style({
              image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                  color: '#fff'
                }),
                fill: new Fill({
                  color: '#3399CC'
                })
              }),
              text: new Text({
                text: size.toString(),
                fill: new Fill({
                  color: '#fff'
                })
              })
            });
            styleCache[size] = style;
          }
          return style;
        }
        

      });

        this.map = new Map({
            target: 'map',
            layers: [
                new TileLayer({
                    source: new OSM()
                }),
                this.clusterLayer
            ],
            view: new View({
                center: fromLonLat([5.77, 45.19]),
                zoom: 7
            })
        });

        */

    },

    //markerClickHandler(event) {
    //},

    /**
     * Method to add locations to the markers property using geojson object
     * If a layer already exist, the geojson object is add to the layer,
     * else the layer is istanciated with the geojson object. Click event are binded to each location.
     * @param {string} layerTitle the title of the layer in which the location is imported
     * @param {object} a geojson object representing the location
     */
    addLocationGeoJson(layerTitle, geojson) {
      if (this.layers[layerTitle] !== undefined) {
        this.layers[layerTitle].addData(geojson);
      } else {
        this.layers[layerTitle] = L.geoJSON(geojson, {
          /**
           * bind click event to open popup on each geojson feature of the layer
           */
          onEachFeature: (feature, layer) => {
            layer.on("click", this.markerClickHandler);
          },
          //prevent bubbling event: click event will ne click on the map for LineString 
          //allow popup to open
          bubblingMouseEvents: false
        });
      }
    },

  defineClusterIcon(cluster) {
    
    //if (this.getFilters.clustering == "clustering_off") {
    //  r = 4;
    //}
    var categoryField = "producerId";
    var children = cluster.getAllChildMarkers();
    var n = children.length;
    var rmax = 20;
    var strokeWidth = 1; //Set clusterpie stroke width
    var r = rmax-2*strokeWidth-(n<10?9:n<100?7:n<1000?4:0);
    if(! this.getSettings.clustering) { r = 4 }

        //r = rmax-2*strokeWidth-(n<10?9:n<100?7:n<1000?4:0), //Calculate clusterpie radius...
    var iconDim = (r+strokeWidth)*2, //...and divIcon dimensions (leaflet really want to know the size)
        data = d3.nest() //Build a dataset for the pie chart
          .key(function(d) { return d.feature.properties[categoryField]; })
          .entries(children, d3.map),
        //bake some svg markup
        html = this.bakeThePie({data: data,
                            valueFunc: function(d){return d.values.length;},
                            strokeWidth: 1,
                            outerRadius: r,
                            innerRadius: 0, //r-10,
                            pieClass: 'cluster-pie',
                            pieLabel: n,
                            pieLabelClass: 'marker-cluster-pie-label',
                            pathClassFunc: function(d){return "category-"+d.data.key;},
                            //pathTitleFunc: function(d){return metadata.fields[categoryField].lookup[d.data.key]+' ('+d.data.values.length+' accident'+(d.data.values.length!=1?'s':'')+')';}
                          }),
        //Create a new divIcon and assign the svg markup to the html property
        myIcon = new L.DivIcon({
            html: html,
            className: 'marker-cluster', 
            iconSize: new L.Point(iconDim, iconDim)
        });
    return myIcon;
  },

  /*function that generates a svg markup for the pie chart*/
  bakeThePie(options) {
    /*data and valueFunc are required*/
    if (!options.data || !options.valueFunc) {
        return '';
    }
    var data = options.data,
        valueFunc = options.valueFunc,
        r = options.outerRadius?options.outerRadius:28, //Default outer radius = 28px
        rInner = options.innerRadius?options.innerRadius: 0, //r-10, //Default inner radius = r-10
        strokeWidth = options.strokeWidth?options.strokeWidth:1, //Default stroke is 1
        pathClassFunc = options.pathClassFunc?options.pathClassFunc:function(){return '';}, //Class for each path
        pathTitleFunc = options.pathTitleFunc?options.pathTitleFunc:function(){return '';}, //Title for each path
        pieClass = options.pieClass?options.pieClass:'marker-cluster-pie', //Class for the whole pie
        pieLabel = options.pieLabel?options.pieLabel:d3.sum(data,valueFunc), //Label for the whole pie
        pieLabelClass = options.pieLabelClass?options.pieLabelClass:'marker-cluster-pie-label',//Class for the pie label
        
        origo = (r+strokeWidth), //Center coordinate
        w = origo*2, //width and height of the svg element
        h = w,
        donut = d3.pie(), //d3.layout.pie(),
        arc = d3.arc().innerRadius(rInner).outerRadius(r); //d3.svg.arc().innerRadius(rInner).outerRadius(r);
        
        
    //Create an svg element
    //var svg = document.createElementNS(d3.ns.prefix.svg, 'svg');
    var svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
    //Create the pie chart
    var vis = d3.select(svg)
        .data([data])
        .attr('class', pieClass)
        .attr('width', w)
        .attr('height', h);
        
    var arcs = vis.selectAll('g.arc')
        .data(donut.value(valueFunc))
        .enter().append('svg:g')
        .attr('class', 'arc')
        .attr('transform', 'translate(' + origo + ',' + origo + ')');
    
    arcs.append('svg:path')
        .attr('class', pathClassFunc)
        //.attr('stroke-width', strokeWidth)
        .attr('d', arc)
        .append('svg:title')
          .text(pathTitleFunc);
    
    if(r > 4) {
      vis.append('text')
        .attr('x',origo)
        .attr('y',origo)
        .attr('class', pieLabelClass)
        .attr('text-anchor', 'middle')
        //.attr('dominant-baseline', 'central')
        //IE doesn't seem to support dominant-baseline, but setting dy to .3em does the trick
        .attr('dy','.3em')
        .text(pieLabel);
    }
    //Return the svg-markup rather than the actual element
    return this.serializeXmlNode(svg);
},

/*Helper function*/
serializeXmlNode(xmlNode) {
    if (typeof window.XMLSerializer != "undefined") {
        return (new window.XMLSerializer()).serializeToString(xmlNode);
    } else if (typeof xmlNode.xml != "undefined") {
        return xmlNode.xml;
    }
    return "";
},

    refreshMapWithMarkers() {

      //The markers are removed from the map
      this.map.removeLayer(this.markers["observations"]);
      
      //The makers to diplay are reseted
      //this.markers.observations =  L.layerGroup();

      //this.markers.observations = L.markerClusterGroup({
      //  maxClusterRadius: 25,
      //  iconCreateFunction: this.defineClusterIcon
      //});

      console.log("Settings:");
      console.log(this.getSettings);

      var clusterRadius = 25;
      if(! this.getSettings.clustering) { clusterRadius = 1 }

      this.markers.observations = L.markerClusterGroup({
        maxClusterRadius: clusterRadius,
        iconCreateFunction: this.defineClusterIcon
      });

      //The layers array is reseted and filled with mapItems items form Vuex observation store array
      this.layers = [];
      if (this.getMapItems.length > 0) {
        this.getMapItems.forEach(element => {
          //document ids are save if geojson properties object
          element.samplingFeature.properties.ids = element.documentId;
          element.samplingFeature.properties.producerId = element.producerId;
          //console.log("Producer ID: " + element.producerId);
          //layers array is filled with the geojson of mapItems array
          this.addLocationGeoJson("observations", element.samplingFeature);
        });

        //The geojson of the layer observation are add to the marker cluster group 
        this.markers["observations"].addLayer(this.layers["observations"]);

        //Markers are printed onto the map
        for (let layerTitle in this.markers) {
          this.map.addLayer(this.markers[layerTitle]);
        }
      }
      

      /*
        this.vectorSource.clear();
        var geoJsonFormatter = new GeoJSON();
        this.getMapItems.forEach(element => {
            element.samplingFeature.properties.ids = element.documentId;
            var feature = geoJsonFormatter.readFeature(element.samplingFeature , 
                                                             {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'});
            var type = feature.getGeometry().getType();
            if (type == 'Point') {
              this.vectorSource.addFeature(feature);
            }
            //TODO: how to do clustering of other feature types?
            
        });
        */
    },

    zoomInObs(id) {
    }

  },
  mounted() {
    //Initialisation of the map when the component is mounted
    this.initMap();
  },
  created() {
    /**
     * Initialisation of the event listener when the component is created.
     * On "meta-obs-clicked" event the map is zoomed in a given observation
     */
    this.$root.$on("meta-obs-clicked", id => {
      this.zoomInObs(id);
    });
  }
};
</script>
